import React, { Component,useEffect,useState } from 'react'
import { Button, Label, Dimmer, Loader, Icon, Modal, Popup } from 'semantic-ui-react'

import Success from '../assets/images/alert/success.png'
import Error from '../assets/images/alert/error.png'
import Warning from '../assets/images/alert/warning.png'
import Info from '../assets/images/alert/info.png'

export default function PopMessage(props) {

   function PassCallback(data){
     props.callback(data);
   }

    return (
     <React.Fragment>

         {/*-----------------------------------------------------------
           POP MESSAGE
           ----------------------------------------------------------*/}
          {props.data.intent=='popup'&&<Modal className="animate__animated animate__slideInDown animate__faster" size={'mini'} open={'open'} centered={props.data.settings.centered} onClose={()=>PassCallback({intent:props.data.settings.onclose?'close':''})}>
            <Modal.Content className="alert-content-wrapper" scrolling>
              <img src={props.data.settings.icon=='warning'?Warning:props.data.settings.icon=='info'?Info:Error}/>
              <h1>{props.data.settings.title}</h1>

              {props.data.settings.data.map(function(row, key){
                     return <React.Fragment key={key}>
                       <p>{row.reference}</p>
              </React.Fragment>})}
             
            </Modal.Content>
          </Modal>}



      </React.Fragment>
    );

}
